// extracted by mini-css-extract-plugin
export default {"modalWrapper":"AuthModal_modalWrapper__KF0vy","modalBody":"AuthModal_modalBody__fkPp9","content":"AuthModal_content__wTGp+"};